import * as XLSX from 'xlsx-js-style';
import { FormStatusEnum } from '@entities/leadCollector';
import { getRouteForm } from '@shared/constants/router';

export interface FormLink {
  linkToken: string;
  status: string;
}

const getStatusText = (status: string): string => {
  const normalizedStatus = status.toUpperCase();
  if (normalizedStatus === FormStatusEnum.USED) return 'Да';
  if (normalizedStatus === FormStatusEnum.ACTIVE) return 'Пока еще не заполнена';
  return status;
};

const saveExcelFile = async (workbook: XLSX.WorkBook): Promise<void> => {
  if (!window.showSaveFilePicker) {
    XLSX.writeFile(workbook, 'Ссылки.xlsx');
    return;
  }

  try {
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const handle = await window.showSaveFilePicker({
      suggestedName: 'Ссылки.xlsx',
    });

    const writable = await handle.createWritable();
    await writable.write(excelBuffer);
    await writable.close();
  } catch (error) {
    console.error(error);
    XLSX.writeFile(workbook, 'Ссылки.xlsx');
  }
};

const HEADER_CELLS = ['A1', 'B1', 'C1', 'D1'];
const COLUMN_WIDTHS = {
  SIMPLE: [{ wch: 40 }, { wch: 15 }, { wch: 30 }],
  FULL: [{ wch: 40 }, { wch: 15 }, { wch: 30 }, { wch: 30 }],
};

const getFormLinkUrl = (linkToken: string): string => {
  return `${globalThis.location.origin}${getRouteForm(linkToken)}`;
};

export const exportLinksToExcel = async (formLinks: FormLink[], isSimpleFormat = false): Promise<void> => {
  const headers = isSimpleFormat
    ? ['Ссылка на форму', 'Отправлено?', 'ФИО получателя']
    : ['Ссылка на форму', 'Отправлено?', 'ФИО получателя', 'Форма заполнена получателем?'];

  const data = isSimpleFormat
    ? formLinks.map((link) => [getFormLinkUrl(link.linkToken), '', ''])
    : formLinks.map((link) => [getFormLinkUrl(link.linkToken), '', '', getStatusText(link.status)]);

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);

  const greenColor = 'E8F5E9';
  const headerGreenStyle = {
    fill: {
      fgColor: { rgb: greenColor },
    },
    font: { bold: true },
  };

  const headerCells = isSimpleFormat ? HEADER_CELLS.slice(0, 3) : HEADER_CELLS;
  for (const cell of headerCells) {
    worksheet[cell].s = headerGreenStyle;
  }

  worksheet['!cols'] = isSimpleFormat ? COLUMN_WIDTHS.SIMPLE : COLUMN_WIDTHS.FULL;

  const wrapTextStyle = { alignment: { wrapText: true } };

  for (const cellAddress in worksheet) {
    if (cellAddress.startsWith('!')) continue;
    worksheet[cellAddress].s = { ...worksheet[cellAddress].s, ...wrapTextStyle };
  }

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Ссылки');
  await saveExcelFile(workbook);
};
